var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 2.5h-1.312V1.078a.353.353 0 0 0-.329-.328H9.08a.332.332 0 0 0-.328.328V2.5h-3.5V1.078A.353.353 0 0 0 4.923.75H3.829a.332.332 0 0 0-.328.328V2.5H2.188C1.45 2.5.876 3.102.876 3.813v9.624c0 .739.574 1.313 1.312 1.313h9.625c.711 0 1.313-.574 1.313-1.313V3.813A1.33 1.33 0 0 0 11.813 2.5Zm-.164 10.938H2.352c-.11 0-.164-.055-.164-.165V5.125h9.625v8.148c0 .11-.082.165-.164.165Z"
  })));
};
export default SvgCalendar;